import { render } from "./ThumbnailView.vue?vue&type=template&id=38fa7cc1&scoped=true"
import script from "./ThumbnailView.vue?vue&type=script&lang=js"
export * from "./ThumbnailView.vue?vue&type=script&lang=js"

import "./ThumbnailView.vue?vue&type=style&index=0&id=38fa7cc1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38fa7cc1"]])

export default __exports__